import { Row, Col } from "antd";
import CustomAreaChart from "./AreaChart";
import CustomBarChart from "./BarChart";
import { CustomPieChart } from "./PieChart";
import { getRandomColor } from "../../../helpers/helper";

const MetricCard = ({
  title,
  subTitle,
  displayValue,
  chartType = "",
  chartData = [],
  seriesMap = {},
  markHighest = false,
  valueMapping={},
  style = {}
}) => {
  // === LOGIC UNTOUCHED ===
  if (
    markHighest &&
    Array.isArray(chartData) &&
    chartData.length > 0 &&
    !displayValue
  ) {
    let maxVal = 0;
    let maxValKey = "NaN";
    if (Object.keys(chartData?.[0]).length == 2) {
      for (var value of chartData) {
        if (Object.values(value)[1] > maxVal) {
          maxVal = Object.values(value)[1];
          maxValKey = Object.values(value)[0];
        }
      }
      displayValue = maxVal;
      subTitle = "Highest by " + maxValKey;
    }
  } else {
    if (!displayValue) displayValue = chartData;
  }

  const COLOR = getRandomColor();
  const showChart = chartType && chartType !== "metric" && chartData.length > 0;

  return (
    <div
      className={`
  rounded-xl
  px-3 py-2
  bg-white
  shadow-[0_4px_8px_rgba(15,23,42,0.08)]
  hover:shadow-[0_10px_22px_rgba(15,23,42,0.14)]
  transition-all duration-200 ease-out
  w-full
`}

      style={style}
    >
      <Row justify="space-between" align="middle" gutter={[10, 8]}>
        {/* LEFT SIDE */}
        <Col
          className="flex flex-col justify-center min-h-[72px]"
          span={showChart ? 16 : 24}
        >
          {title && (
            <div
              className={`
                text-[11px]
                font-semibold
                tracking-wide
                text-slate-500
                uppercase
                leading-snug
                whitespace-normal
                break-words
              `}
            >
              {title}
            </div>
          )}

          <div className="mt-1 flex items-baseline gap-1">
            <div
              className={valueMapping.value?"text-[20px] font-semibold leading-snug":"text-xl font-semibold leading-snug"}
              style={{ color: COLOR }}
            >
              {valueMapping.value? `${displayValue[valueMapping['label']]} - ${displayValue[valueMapping['value']]}` : String(displayValue)}
            </div>
          </div>

          {subTitle && (
            <div
              className="text-[12px] mt-1 leading-snug text-slate-500 whitespace-normal break-words"
            >
              {subTitle}
            </div>
          )}
        </Col>

        {/* RIGHT SIDE - CHART */}
        {showChart && (
          <Col className="flex items-center justify-end" span={8}>
            <div className="w-full flex items-center justify-center">
              {chartType === "area" && (
                <CustomAreaChart
                  style={{ width: "100%" }}
                  maxHeight={150}
                  chartData={chartData}
                  seriesMap={seriesMap}
                />
              )}

              {chartType === "bar" && (
                <CustomBarChart
                  style={{ width: "100%" }}
                  maxHeight={150}
                  chartData={chartData}
                  seriesMap={seriesMap}
                />
              )}

              {chartType === "pie" && (
                <CustomPieChart
                  style={{ width: "100%" }}
                  maxHeight={150}
                  chartData={chartData}
                  seriesMap={seriesMap}
                />
              )}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default MetricCard;
